import { HttpErrorResponse } from '@angular/common/http';

export class UploadUsersListFailure {
    static readonly type = '[User] UploadUsersListFailure';

    constructor(
        public payload: {
            response: HttpErrorResponse;
        }
    ) {}
}
